import classnames from 'classnames'
import React, { type JSX } from 'react'
import {
  CustomLinkProps,
  DefaultLinkProps,
  isCustomProps,
  Link,
} from '../../Link/Link'

export type {
  DefaultLinkProps as DefaultBreadcrumbLinkProps,
  CustomLinkProps as CustomBreadcrumbLinkProps,
} from '../../Link/Link'

export function BreadcrumbLink(props: DefaultLinkProps): JSX.Element
export function BreadcrumbLink<T>(props: CustomLinkProps<T>): JSX.Element
export function BreadcrumbLink<FCProps = DefaultLinkProps>({
  className,
  ...passThroughProps
}: DefaultLinkProps | CustomLinkProps<FCProps>): JSX.Element {
  const classes = classnames(className, 'usa-breadcrumb__link')

  const linkProps = {
    ...passThroughProps,
    className: classes,
  } as DefaultLinkProps | CustomLinkProps<FCProps>

  if (isCustomProps(linkProps)) {
    return <Link<FCProps> {...linkProps} variant="unstyled" />
  }

  return <Link {...linkProps} variant="unstyled" />
}
